export default __webpack_public_path__ + "static/media/factors-nutrition.7e37a051.jpg";